import React from 'react';
import { Tabs, Typography } from 'antd';
import UsersTab from './UsersTab';
import RolesTab from './RolesTab';
import ProfilesTab from './ProfilesTab'; // Importamos el componente de la pestaña de perfiles

const { Title } = Typography;

const UserManagementPage = () => {
    
    // Definición de las pestañas
    const tabItems = [
        {
            key: '1',
            label: `Usuarios`,
            children: <UsersTab />, 
        },
        {
            key: '2',
            label: `Roles`,
            children: <RolesTab />,
        },
        {
            key: '3',
            label: `Perfiles`,
            // Reemplazamos el texto con el componente funcional de Perfiles
            children: <ProfilesTab />,
        },
    ];

    return (
        <div>
            <Title level={2}>Gestión de Usuarios y Permisos</Title>
            <Tabs defaultActiveKey="1" items={tabItems} />
        </div>
    );
};

export default UserManagementPage;
